import Preloader from "@/components/common/Preloader";

import AuthImageMove from "@/components/others/AuthImageMove";
import LoginForm from "@/components/others/LoginForm";
import React, { useState, useEffect } from "react";
import MetaComponent from "@/components/common/MetaComponent";

const metadata = {
  title:
    "Login || GVK EDU – Premier Pharmacy Exam Coaching & Comprehensive Study Resources Since 2014",
  description:
    "Elevate your e-learning content with Educrat, the most impressive LMS template for online courses, education and LMS platforms.",
};
export default function LoginPage() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="main-content">
      <MetaComponent meta={metadata} />
      <Preloader />

      {/* <HeaderAuth /> */}
      <div className="content-wrapper js-content-wrapper overflow-hidden">
        <section className="form-page js-mouse-move-container" style={{
          paddingTop: isMobile ? '0' : undefined,
          alignItems: isMobile ? 'flex-start' : 'center'
        }}>
          <div className="form-page__img" style={isMobile ? { 
            height: '0', 
            maxHeight: '0', 
            overflow: 'hidden',
            margin: '0',
            padding: '0'
          } : {}}>
            <AuthImageMove />
          </div>
          <LoginForm />
        </section>
      </div>
    </div>
  );
}
